module.exports = __webpack_public_path__ + "img/medical-mas-image.db2bbb46.png";